import { render, staticRenderFns } from "./StatsUtilisateurComponent.vue?vue&type=template&id=3a5af2a3"
import script from "./StatsUtilisateurComponent.vue?vue&type=script&lang=js"
export * from "./StatsUtilisateurComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports